import { FC, PropsWithChildren, useEffect } from "react";
import { motion, useAnimation } from "framer-motion";

type Props = PropsWithChildren<{
  delay?: number;
}>;

export const FadeIn: FC<Props> = ({ children, delay = 0 }): JSX.Element => {
  const controls = useAnimation();

  useEffect(() => {
    controls.start({
      opacity: 1,
      // translateY: 0,
      transition: { duration: 0.5, delay, ease: "easeOut" },
    });
  }, [controls, delay]);

  return (
    <motion.div
      initial={{
        opacity: 0,
        // translateY: 30,
      }}
      animate={controls}
    >
      {children}
    </motion.div>
  );
};
